import React, {useState} from 'react';
import {toast} from "react-toastify";
import Button from "../../../../components/common/Button";
import FetchService from "../../../../services/api/FetchService";
import {ErrorToastSettings} from "../../../../services/toast/toastSettings";
import styles from './styles.module.scss';

interface IProps {
    companyId: number;
    checklistId: number;
    checklistName: string;
}

const ExportChecklistCsvButton: React.FC<IProps> = ({companyId, checklistId, checklistName}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleExport = async () => {
        try {
            setIsLoading(true);
            const res = await FetchService.getChecklistManagementItemsCsv(companyId, checklistId);
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${checklistName || 'checklist-' + checklistId}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error('Не вдалося експортувати чеклист', ErrorToastSettings);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.exportBtn}>
            <Button
                text={isLoading ? 'Експорт...' : 'Експортувати CSV'}
                disabled={isLoading}
                onClick={handleExport}
            />
        </div>
    );
};

export default ExportChecklistCsvButton;
